export function scaleToFill(canvas, img) {
    const ctx = canvas.getContext('2d');
    // get the scale
    var scale = Math.max(canvas.width / img.width, canvas.height / img.height);
    // get the top left position of the image
    var x = (canvas.width / 2) - (img.width / 2) * scale;
    var y = (canvas.height / 2) - (img.height / 2) * scale;
    ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
}
/**
 *
 * @param img
 * @param canvas
 * @param ctx
 */
export function scaleToFit(canvas, img) {
    // get the scale
    var scale = Math.min(canvas.width / img.width, canvas.height / img.height);
    const width = img.width * scale;
    const height = img.height * scale;
    const ctx = canvas.getContext('2d');
    ctx.canvas.width = width;
    ctx.canvas.height = height;
    ctx.drawImage(img, 0, 0, width, height);
}
/**
 *
 * @param canvas
 * @param img
 * @param width
 * @param height
 */
export function drawImageOriginalSize(canvas, img, containerWidth) {
    // aspect ratio
    const a = img.width / img.height;
    const h = containerWidth / a;
    canvas.height = h;
    canvas.width = containerWidth;
    // get the scale
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, containerWidth, containerWidth / a);
}
function fetchStatusHandler(response) {
    if (response.status === 200) {
        return response;
    }
    else {
        throw new Error(`Unable to load Image: ${response.statusText}`);
    }
}
const options = {
    crossOrigin: "anonymous"
};
/**
 *
 * @param src
 */
export async function loadImage(src) {
    return fetch(src, options)
        .then(fetchStatusHandler)
        .then((data) => data.blob())
        .then(drawImage);
}
async function drawImage(blob) {
    return new Promise((res) => {
        var img = new Image();
        img.onload = () => {
            res(img);
        };
        img.src = URL.createObjectURL(blob);
    });
}
